// Styles for Uploader component
/** @type {import('react').CSSProperties} */
export const addLinkButtonContainerStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  margin: 10,
};

export const modalInputStyle = {
  marginTop: 8,
  marginBottom: 8,
  borderRadius: 6,
  fontSize: 14,
  padding: 8,
};

export const errorTextStyle = {
  color: 'red',
  marginTop: 8,
  fontSize: 12,
};
